import { Icon } from 'components/icon'
import React, { FC, useEffect, useRef, useState } from 'react'
import ReactDOM from 'react-dom'

type Props = {
	children: React.ReactNode
	text: string
	transform?: string
	icon?: string
	twoIcon?: string
	iconClassName?: string
	useInlineBlock?: boolean
	className?: string
}

export const Tooltip: FC<Props> = ({
	children,
	text,
	icon,
	transform = '10',
	twoIcon = '',
	iconClassName = 'w-5 h-5 flex-shrink-0 text-black',
	useInlineBlock = true,
	className = ''
}) => {
	const [visible, setVisible] = useState(false)
	const [coords, setCoords] = useState({ top: 0, left: 0 })
	const ref = useRef<HTMLDivElement>(null)

	const showTooltip = (): void => {
		if (ref.current) {
			const rect = ref.current.getBoundingClientRect()
			setCoords({
				top: rect.top - 40,
				left: rect.left + rect.width / 2
			})
		}
		setVisible(true)
	}

	const hideTooltip = (): void => setVisible(false)

	useEffect(() => {
		return () => setVisible(false)
	}, [])

	return (
		<>
			<div
				ref={ref}
				className={useInlineBlock ? 'inline-block' : className}
				onMouseEnter={showTooltip}
				onMouseLeave={hideTooltip}
			>
				{children}
			</div>
			{visible &&
				ReactDOM.createPortal(
					<div
						style={{
							top: coords.top,
							left: coords.left,
							transform: `translateX(-${transform}%)`
						}}
						className="fixed bg-white text-black text-xs rounded px-2 py-1 shadow-xl border border-gray-300 z-[9999] flex items-center gap-2"
					>
						{icon &&
							(twoIcon ? (
								<div className="flex items-center gap-2">
									<Icon fillPath src={icon} className={iconClassName} />
									<Icon fillPath src={twoIcon} className={iconClassName} />
								</div>
							) : (
								<Icon fillPath src={icon} className={iconClassName} />
							))}
						{text}
					</div>,
					document.body
				)}
		</>
	)
}

Tooltip.defaultProps = {
	icon: undefined,
	transform: '10',
	twoIcon: '',
	iconClassName: 'w-5 h-5 flex-shrink-0 text-black',
	useInlineBlock: true,
	className: ''
}
